import React from "react";
import { X, FileCode, MousePointer } from "lucide-react";

/**
 * Chip displayed above chat input showing the currently referenced component.
 * Reusable for both manual component selection and visual editor element selection.
 */
export default function ComponentRefChip({ componentRef, onClear }) {
    if (!componentRef) return null;

    const hasElement = componentRef.elementTag || componentRef.elementSelector;
    const icon = hasElement ? MousePointer : FileCode;
    const Icon = icon;

    return (
        <div className="inline-flex items-center gap-1.5 max-w-full px-2 py-1 bg-blue-50 border border-blue-200 rounded-md text-xs">
            <Icon className="h-3 w-3 text-blue-600 flex-shrink-0" />
            <span className="font-medium text-blue-800 truncate min-w-0">
                {componentRef.componentName}
            </span>
            {hasElement && (
                <span className="text-blue-500 flex-shrink-0">
                    &lt;{componentRef.elementTag}&gt;
                </span>
            )}
            <button
                onClick={onClear}
                className="p-0.5 rounded hover:bg-blue-100 text-blue-400 hover:text-blue-600 flex-shrink-0"
                aria-label="Remove component reference"
            >
                <X className="h-3 w-3" />
            </button>
        </div>
    );
}
